import { GetMethod, PostMethod } from '../../../serviceHelper';
import { getMethods as getCAdESMethods } from './CAdES';
import { getMethods as getPAdESMethods } from './PAdES';
import { getMethods as getXAdESMethods } from './XAdES';

const getMethods = (service: 'dm', controller: 'Signature') => ({
	GetDigitalSignatureParameters: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetDigitalSignatureParameters'
	}),
	GetDocumentSignatures: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDocumentSignatures'
	}),
	GetDocumentTimestamps: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetDocumentTimestamps'
	}),
	CreateArchiveTimestamp: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateArchiveTimestamp'
	}),
	DownloadSignature: new PostMethod<any, any>({
		service,
		controller,
		method: 'DownloadSignature'
	}),
	CheckSignatureAuthentication: new PostMethod<any, any>({
		service,
		controller,
		method: 'CheckSignatureAuthentication'
	}),
	FinalizeSigning: new PostMethod<any, any>({
		service,
		controller,
		method: 'FinalizeSigning'
	}),
	CAdES: getCAdESMethods(service, controller + '/CAdES'),
	PAdES: getPAdESMethods(service, controller + '/PAdES'),
	XAdES: getXAdESMethods(service, controller + '/XAdES')
});

export { getMethods };
